// src/composables/useLocationMapper.js
import { ref } from 'vue';
import axios from 'axios';
import store from "../store";
// const companyId = localStorage.getItem('companyId'); // Asumimos que companyId está disponible globalmente si es necesario

// Simulamos los datos de ubicación para el ejemplo.
// En un caso real, esto vendría de su endpoint de API.
const DTE_LOCATIONS = [
    { code: '01', name: 'Ahuachapán', level: 'DEPARTAMENTO' },
    { code: '02', name: 'Santa Ana', level: 'DEPARTAMENTO' },
    { code: '03', name: 'Sonsonate', level: 'DEPARTAMENTO' },
    { code: '0101', name: 'Ahuachapán', level: 'MUNICIPIO' },
    { code: '0102', name: 'Apaneca', level: 'MUNICIPIO' },
    { code: '0201', name: 'Santa Ana', level: 'MUNICIPIO' },
    { code: '0202', name: 'Candelaria de la Frontera', level: 'MUNICIPIO' },
    // ... más datos ...
];

const locations = ref(DTE_LOCATIONS);
const isLoading = ref(false);

/**
 * Hook para cargar y mapear códigos de ubicación (Departamento/Municipio) a texto.
 */
export function useLocationMapper() {

    // 🛑 FUNCIÓN CRÍTICA: TRADUCE CÓDIGO A TEXTO 🛑
    /**
     * Busca la descripción de un código de ubicación.
     * @param {string} code - El código de departamento o municipio (ej: '02' o '0201').
     * @param {boolean} includeCode - Si debe devolver "CÓDIGO - DESCRIPCIÓN".
     * @returns {string} La descripción o el código si no se encuentra.
     */
    const getLocationDescription = (code, includeCode = true) => {
        if (!code) return '';

        const location = locations.value.find(loc => loc.code === code);

        if (location) {
            return includeCode
                ? `${location.code} - ${location.name}`
                : location.name;
        }

        return includeCode ? `${code}  N/A` : code;
    };

    // Función para simular la carga de datos desde la API
    const fetchLocations = async () => {
        isLoading.value = true;
        //const store = useStore();
        try {
            // 🛑 LÓGICA REAL: Reemplace con su llamada a API 🛑
            const token = localStorage.getItem("accessToken");
            const response = await axios.get(store.state.apiURL + 'locations?company='+localStorage.getItem('companyId'),{ headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' } });
            locations.value = response.data;
            //console.log(response.data);
            // Simulación de delay
            //await new Promise(resolve => setTimeout(resolve, 50));

        } catch (error) {
            console.error("Error cargando el catálogo de ubicaciones:", error);
            // Si falla, usamos el array de fallback o vacío
        } finally {
            isLoading.value = false;
        }
    };

    // Si los datos aún no están cargados, los cargamos una vez.
    if (locations.value.length === 0) {
        fetchLocations();
    }

    return {
        locations,
        isLoading,
        getLocationDescription,
        fetchLocations
    };
}